import { Box, Tooltip } from "@chakra-ui/react";
import { Link } from "@src/components/ui-kit";
import { useSetEditorContent } from "@src/components/ui-kit/TextEditor/hooks/useSetContent";
import {
  EMPTY_EDITOR_LENGTH,
  TextEditor,
  type TextEditorRef,
} from "@src/components/ui-kit/TextEditor/TextEditor";
import { observer } from "mobx-react-lite";
import { useRef } from "react";
import type { Report } from "../../models";

const MAX_TOOLTIP_WIDTH = "400px";

type ProjectTitleProps = Pick<
  Report["__subRows"][0],
  "project_code" | "project_title" | "note" | "project_id"
>;

const ProjectTitle = ({
  project_code,
  project_title,
  note,
  project_id,
}: ProjectTitleProps) => {
  const title = `${project_code} - ${project_title}`;
  const editorRef = useRef<TextEditorRef>(null);

  useSetEditorContent({ ref: editorRef.current, note: note });

  return (
    <Box>
      <Tooltip label={<div>{title}</div>} shouldWrapChildren>
        <Link href={`/projects/detail?id=${project_id}`} isExternal>
          {title}
        </Link>
      </Tooltip>

      {!!note && note.length > EMPTY_EDITOR_LENGTH && (
        <Tooltip
          label={
            <Box maxW={MAX_TOOLTIP_WIDTH}>
              <TextEditor
                ref={editorRef}
                initialValue={note}
                onChange={() => {}}
                isEditable={false}
                attachments={[]}
              />
            </Box>
          }
        >
          <Box>
            <TextEditor
              ref={editorRef}
              initialValue={note}
              onChange={() => {}}
              isEditable={false}
              attachments={[]}
              noOfLines={1}
            />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};

export default observer(ProjectTitle);
